module.exports = __webpack_public_path__ + "static/media/logohorizontal.4057ad5f.png";